import React from 'react';
import { Pie } from '@ant-design/plots';
import { Props, Data } from './types';

const DemoPie: React.FC<Props> = ({ data, total }) => {
  const [dados, setDados] = React.useState<Data[]>([]);

  React.useEffect(() => {
    setDados(data);
  }, [data]);

  const content = `<div style="display:block;" class="themeDashboard"><div style="font-size: 14px" >Total de atendimentos</div><div>${
    total ?? 0
  }</div></div>`;

  const config = {
    appendPadding: 10,
    data: dados,
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.6,

    label: {
      type: 'inner',
      offset: '-50%',
      content: '{value}',
      autoRotate: false,
      style: {
        textAlign: 'center',
        fontSize: 14,
      },
    },

    tooltip: {
      formatter: (datum: any) => {
        dados.map((item) => {
          if (item.type === datum.type) {
            datum.type = `<span style="font-size: 16px">${item.type}</span><br/>
            <br/> <span style="font-size: 22px">${item.value}</span> atendimentos`;
            datum.value = `<span style="font-size: 22px">${item.percentage}%</span> do total de atendimentos`;
          }
          return item;
        });
        return { name: datum.type, value: datum.value };
      },
    },

    legend: {
      maxItemWidth: 130,
    },

    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],

    statistic: {
      title: undefined,
      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        content: content,
      },
    },
  };
  return <Pie {...config} />;
};

export default DemoPie;
